(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-card/assets/javascripts/casino-game-card.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-card/assets/javascripts/casino-game-card.js');

'use strict';

const {
  CasinoGamePreviewSimple
} = svs.components.casino_react.casinoGamePreviewSimple;
const {
  Image
} = svs.content.image_v2;
const {
  CasinoGameCardBadge
} = svs.components.casino_react.casinoGameCard;
const {
  useCallback,
  useState,
  memo
} = React;
const CasinoCardFallback = svs.components.casino_react.casinoCardFallback;
const urlMapping = svs.core.urlMapping;
const {
  ReactButton: Button
} = svs.ui;
const {
  CasinoQuickInfo,
  CasinoCardWrapper
} = svs.components.casino_react;
const CasinoGamePreview = svs.components.casino_react.casinoGamePreview.CasinoGamePreview;
const {
  Card
} = svs.ui.ReactCard;
const {
  CasinoGameBottomInformation,
  CasinoGameRouletteBalls
} = svs.components.casino_react.casino_game_live_info;
const {
  brand
} = svs.casino_react.shared.data;
const {
  useLiveData
} = svs.components.casino_react.casino_store.hooks;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_LG
} = svs.components.lbUtils.useMediaQuery;
const ImageMemoized = memo(Image);
const getFallbackImage = () => {
  let image = 'fallback-img-casino.jpg';
  if (brand === 'momang') {
    image = 'fallback-img-momang.jpg';
  }
  return "".concat(svs.core.config.data.svsconfig.cdn, "/images/casino-react/casino-game-card/").concat(image, "?breakCache=1");
};
const CasinoGameCard = _ref => {
  let {
    gameName,
    isTall,
    containedHover
  } = _ref;
  const gameModel = svs.components.casino.data.gameCache.index[gameName];
  const imageSource = isTall ? gameModel === null || gameModel === void 0 ? void 0 : gameModel.tallLobbyImage : gameModel === null || gameModel === void 0 ? void 0 : gameModel.lobbyImage;
  const isSmallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_LG));
  const [showQuickInfoModal, setShowQuickInfoModal] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const {
    liveData,
    jackpotData
  } = useLiveData(gameModel);
  const onImageLoaded = useCallback(() => {
    setImageLoaded(true);
  }, []);
  const onToggleQuickInfo = useCallback(() => {
    setShowQuickInfoModal(value => !value);
  }, []);
  const gameInfoPath = "".concat(urlMapping.get('casinoGameInfo'), "/").concat(gameName);
  if (!gameModel) {
    return React.createElement(CasinoCardFallback, {
      title: gameName
    });
  }
  const {
    name,
    title,
    badge,
    liveResultType,
    liveCategory
  } = gameModel;
  if (isSmallScreen) {
    return React.createElement(React.Fragment, null, React.createElement(CasinoCardWrapper, null, React.createElement("div", {
      style: {
        opacity: imageLoaded ? 1 : 0,
        transition: 'opacity 200ms'
      }
    }, React.createElement(Button, {
      className: "padding-0",
      "data-name": name,
      "data-title": title,
      onClick: onToggleQuickInfo,
      title: "L\xE4s mer om ".concat(title)
    }, React.createElement(React.Fragment, null, React.createElement(CasinoGameCardBadge, {
      badge: badge,
      jackpotData: jackpotData
    }), React.createElement(ImageMemoized, {
      fallbackImage: getFallbackImage(),
      image: imageSource,
      onLoadCallback: onImageLoaded
    }), React.createElement(CasinoGameRouletteBalls, {
      liveCategory: liveCategory,
      liveData: liveData,
      liveResultType: liveResultType
    }), React.createElement(CasinoGameBottomInformation, {
      gameModel: gameModel,
      liveData: liveData
    }))))), showQuickInfoModal && React.createElement(CasinoQuickInfo, {
      gameModel: gameModel,
      imageSource: imageSource,
      showQuickInfoModal: showQuickInfoModal,
      toggleQuickInfo: onToggleQuickInfo
    }));
  }
  return React.createElement("div", {
    className: "casino-game-card-wrapper"
  }, React.createElement(CasinoCardWrapper, null, React.createElement("div", {
    style: {
      opacity: imageLoaded ? 1 : 0,
      transition: 'opacity 200ms'
    }
  }, React.createElement("a", {
    "data-name": name,
    "data-title": title,
    href: gameInfoPath,
    rel: "follow",
    title: "L\xE4s mer om ".concat(title)
  }, React.createElement(CasinoGameCardBadge, {
    badge: badge,
    jackpotData: jackpotData
  }), React.createElement(ImageMemoized, {
    fallbackImage: getFallbackImage(),
    image: imageSource,
    onLoadCallback: onImageLoaded
  }), React.createElement(CasinoGameRouletteBalls, {
    liveCategory: liveCategory,
    liveData: liveData,
    liveResultType: liveResultType
  }), React.createElement(CasinoGameBottomInformation, {
    gameModel: gameModel,
    liveData: liveData
  })))), !containedHover && React.createElement(Card, {
    className: "casino-game-card-hover-content"
  }, React.createElement(React.Fragment, null, React.createElement(CasinoGameCardBadge, {
    badge: badge,
    jackpotData: jackpotData
  }), React.createElement(CasinoGamePreview, {
    gameModel: gameModel,
    imageSource: imageSource
  }))), containedHover && React.createElement("div", {
    className: "casino-game-card-hover-content--contained"
  }, React.createElement(CasinoGamePreviewSimple, {
    gameModel: gameModel
  })));
};
setGlobal('svs.components.casino_react.casinoGameCard.CasinoGameCard', React.memo(CasinoGameCard));

 })(window);